module.exports = __webpack_public_path__ + "img/ic_next_testimonial.0a6a75cb.svg";